import i18next from 'i18next';
import React, { FC, ReactElement } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import AppModal from './app-modal/AppModal';

type PrivacyModalProps = {
  show: boolean;
  onPositive: () => void;
  onNegative: () => void;
  onSupport: () => void;
};

export const PrivacyModal: FC<PrivacyModalProps> = ({ show, onPositive, onNegative, onSupport }: PrivacyModalProps): ReactElement => {
  return (
    <AppModal show={show} size="lg" onHide={() => onNegative()}>
      <div style={{ color: '#444', lineHeight: 2 }}>
        <Modal.Header closeButton>
          <Modal.Title>{i18next.t('loginPage.welcome')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: i18next.t('privacyModal.body') }} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="link" className="me-auto text-decoration-underline" onClick={() => onSupport()}>
            {i18next.t('privacyModal.contactSupport')}
          </Button>
          <Button variant="primary" onClick={() => onPositive()}>
            {i18next.t('privacyModal.iAgree')}
          </Button>
        </Modal.Footer>
      </div>
    </AppModal>
  );
};

export default PrivacyModal;
